<template>
  <div class="box select">
    <div class="entRisk_head">
      <div class="left_head">
        <el-page-header @back="goBack" :content="secondTitle" style="color:#AECFDC;width:100px;"></el-page-header>
        <span style="margin-right:20px">质量安全红线管理</span>
        <span>已检查事项</span>
      </div>

      <div>
        <span class="hand">更多统计</span>
        <i class="el-icon-right"></i>
      </div>
    </div>
    <div class="content_second">
      <div class="table_head">
        <div style="margin-right:50px;line-height:40px">巡查项目</div>
        <div>
          <el-select
            v-model="type"
            popper-class="fen-sel"
            class="fen-val"
            placeholder="选择项目"
            @change="doFilte"
          >
            <el-option v-for="item in projects" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
      </div>
      <div class="build-CURD">
        <div class="build-table ceshi">
          <el-table
            class="ceshi"
            :data="tableData"
            style="width: 100%; background-color:#010D27;"
            height="100%"
            stripe
            :header-cell-style="{background:'#010D27',color:'#fff'}"
            :cell-style="cellClass"
            @cell-click="cellClick"
            :span-method="objectSpanMethod"
            ref="multipleTable"
            @selection-change="handleSelectionChange"
          >
            <template slot="empty">
              <p>{{dataText}}</p>
            </template>
            <!-- <el-table-column label="序号">
            <template slot-scope="scope">
              <span>{{ scope.row.index }}</span>
            </template>
            </el-table-column>-->
            <el-table-column label="编号" width="100">
              <template slot-scope="scope">
                <span>{{scope.row.typeNumber}}</span>
              </template>
            </el-table-column>
            <el-table-column label="分项" width="100">
              <template slot-scope="scope">
                <span>{{ scope.row.typeItem }}</span>
              </template>
            </el-table-column>
            <el-table-column label="红线条文">
              <template slot-scope="scope">
                <span>{{ scope.row.redClause}}</span>
              </template>
            </el-table-column>
            <el-table-column label="引发后果" width="100">
              <template slot-scope="scope">
                <span>{{ scope.row.consequence}}</span>
              </template>
            </el-table-column>
            <el-table-column label="类别" width="100">
              <template slot-scope="scope">
                <span>{{ scope.row.redType}}</span>
              </template>
            </el-table-column>
            <el-table-column label="责任岗位" width="100">
              <template slot-scope="scope">
                <span>{{ scope.row.resPosition}}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="操作" align="right" width="100"> -->
            <!-- <template slot="header">
                <el-checkbox
                  :indeterminate="isIndeterminate"
                  v-model="checkAll"
                  @change="handleCheckAllChange"
                >操作</el-checkbox>
            </template>-->
            <!-- <template slot-scope="scope" class="checkbox-div">
                <el-checkbox
                  v-model="scope.row.checked"
                  @change="handleCheckOneChange(scope.row.id)"
                ></el-checkbox>
              </template>
            </el-table-column>-->
            <el-table-column type="selection" width="55"></el-table-column>
            <!-- 编辑窗口 -->
            <!-- <el-dialog
            title="编辑"
            :visible.sync="editFormVisible"
            center
            :append-to-body="true"
            :before-close="handleClose"
            :lock-scroll="false"
            width="30%"
          >
            <el-form :model="editForm" ref="editForm">
              <el-form-item label="名称：">
                <el-input v-model="editForm.name" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="楼号：">
                <el-input v-model="editForm.type" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="类型：">
                <el-input v-model="editForm.adddress" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="所属：">
                <el-input v-model="editForm.people" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="人数：">
                <el-input v-model="editForm.contract" autocomplete="off"></el-input>
              </el-form-item>
            </el-form>
            </el-dialog>-->
          </el-table>
        </div>
        <!-- 分页展示 -->
        <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[3, 5, 10,20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalItems"
        ></el-pagination>-->
      </div>
      <div class="table_btn">
        <el-button type="primary" @click="addQsRedManager">提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import myHttp from '../../untils/port'
import util from '../../untils/util.js'
import base from '../../untils/base'
export default {
  data() {
    return {
      dataText: '暂无数据',
      secondTitle: '',
      groupId: '',
      prevPage: '', //上一个页面
      istowe: true,
      tableData: [],
      checkAll: false,
      isIndeterminate: true,
      type: '',
      projects: [],
      joinType: '3',
      name: '',
      multipleSelection: [],
      redLineIds: '',
      spanArr: [],
      pos: 0
    }
  },
  mounted() {
    // this.groupId = util.session.get('proId')
    this.groupId = this.$store.state.groupId
    if ('' == this.groupId || undefined == this.groupId) {
      this.groupId = util.session.get('groupId')
    }
    this.getPro()
    this.getData()

    // console.log(this.groupId)
  },
  methods: {
    //获取项目
    getPro() {
      var that = this
      myHttp
        .secProjectByEntIdAndJoinType({
          entId: this.groupId,
          joinType: this.joinType,
          name: ''
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              var project = resp.data.data.list
              // var project = resp.data.data.projectf
              // that.secondTitle = ''
              that.projects = project
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
    },
    // 获取数据
    getData() {
      var that = this
      myHttp.findDetailsListPc().then(
        function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.dateList || []
            that.tableData = list
            for (var i = 0; i < that.tableData.length; i++) {
              if (i === 0) {
                that.spanArr.push(1)
                that.pos = 0
              } else {
                // 判断当前元素与上一个元素是否相同
                if (
                  that.tableData[i].typeItem === that.tableData[i - 1].typeItem
                ) {
                  that.spanArr[that.pos] += 1
                  that.spanArr.push(0)
                } else {
                  that.spanArr.push(1)
                  that.pos = i
                }
              }
            }
          } else {
            that.$message.error(resp.data.msg)
          }
        },
        function() {}
      )
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        const _row = this.spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },
    goBack() {
      this.$router.go(-1)
      //window.history.back()
    },

    cellClass({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 1) {
        return 'background-color:#4C9AFF;color:#fff;border:0'
      } else {
        return 'background-color:#010D27'
      }
    },
    cellClick(column, columnIndex) {
      // console.log(columnIndex.colSpan)
    },
    handleCheckAllChange(val) {
      console.info('check all change is ', val)
      this.isIndeterminate = false
      this.tableData.forEach(item => {
        item.checked = val
      })
    },
    doFilte(e) {
      // console.log(e)
      this.projectId = e
    },
    handleSelectionChange(val) {
      // console.log(val)
      var redLineIds = ''
      this.multipleSelection = val
      for (var i = 0; i < this.multipleSelection.length; i++) {
        if (i == 0) {
          redLineIds = this.multipleSelection[i].id
        } else {
          redLineIds += ',' + this.multipleSelection[i].id
        }
      }
      this.redLineIds = redLineIds
    },
    // 提交红线
    addQsRedManager() {
      var that = this
      // 红线id
      // for (var i = 0; i < this.multipleSelection.length; i++) {
      //   if (i == 0) {
      //     redLineIds = this.multipleSelection[i].id
      //   } else {
      //     redLineIds += ',' + this.multipleSelection[i].id
      //   }
      // }

      this.$confirm('确定提交, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          myHttp
            .addQsRedManager({
              redLineIds: this.redLineIds,
              projectId: this.projectId,
              personId: util.session.get('user').id,
              personName: util.session.get('user').name,
              loginPlatform: this.joinType,
              entId: this.groupId
            })
            .then(function(resp) {
              if (resp.data.code == '200') {
                that.$message({
                  type: 'success',
                  message: '提交成功!'
                })
                that.$router.push({ name: 'redLine' })
                // that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
        })
        .catch(err => {})
    }
  }
}
</script>
<style scoped>
* {
  box-sizing: border-box;
}

.box {
  width: 100%;
  position: relative;
  /* height: calc(100vh - 120px); */
  height: 100%;
  background: #010d27;
  color: #aecfdc;
  box-sizing: border-box;
}
.entRisk_head {
  width: 100%;
  height: 50px;
  background: #031260;
  display: flex;
  padding: 0px 50px;
  align-items: center;
  justify-content: space-between;
}
.left_head {
  /* width: 20%; */
  display: flex;
  justify-content: space-between;
}
.table_head {
  display: flex;
  width: 94%;
  margin: 20px auto;
  color: #fff;
  height: 40px;
}
.build-CURD {
  width: 95%;
  height: 100%;
  position: relative;
  background: #010d27;
  margin: 0 auto;
  height: calc(100% - 100px);
  color: #fff;
  overflow: hidden;
}
.content_second {
  height: calc(100% - 80px);
}
.build-table {
  height: 100%;
  background: #010d27;
}
.el-table >>> .cell {
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}
.el-table th,
.el-table tr {
  background-color: #000;
}
.build-bar >>> .btnLef {
  margin-left: 200px;
}

.el-form >>> .upload-demo {
  width: 220px;
  margin-bottom: 20px;
  margin-left: 100px;
}

.add-form >>> .el-upload-dragger {
  width: 100%;
  height: 100px;
}

.build-bar .add-user >>> span {
  text-align: center;
  margin-left: 2px;
}

.add-form .el-form-item {
  width: 80%;
}

.el-dropdown-link {
  cursor: pointer;
  color: #666;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.role-tree {
  overflow-y: scroll;
  min-height: 200px;
}
.build-table {
  position: relative;
  width: 100%;
  margin: 0 auto;
  /* height: calc(100% - 150px); */
}
.build-bar {
  padding: 10px 20px;
  text-align: left;
}
.hand {
  cursor: pointer;
}
img {
  margin-left: 60px;
}
.table-head {
  background: #17b2fe;
}
.table-head-cell {
  background: #17b2fe;
  color: #fff;
}

.el-table--enable-row-hover .el-table__body tr > td {
  background-color: #212e3e !important;
}
.ceshi >>> .el-table td,
.ceshi >>> .el-table th.is-leaf {
  border: 1px solid #707070;
  color: #fff;
}
.ceshi >>> .el-table th.is-leaf {
  border: 1px solid #010d27;
}
.ceshi >>> .el-table:before {
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0px;
}
.table_btn {
  height: 50px;
}

.ceshi >>> .el-checkbox__inner {
  display: inline-block;
  position: relative;
  border: 2px solid #ffbc01;
  border-radius: 50%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 25px;
  height: 25px;
  background-color: #010d27;
  z-index: 1;
  -webkit-transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
  transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
}
.ceshi >>> .el-checkbox__input.is-checked .el-checkbox__inner::after {
  -webkit-transform: rotate(45deg) scaleY(1);
  transform: rotate(45deg) scaleY(1);
}
.ceshi >>> .el-checkbox__inner::after {
  box-sizing: content-box;
  content: '';
  border: 2px solid #ffbc01;
  border-left: 0;
  border-top: 0;
  height: 10px;
  left: 8px;
  position: absolute;
  top: 3px;
  width: 3px;
  transform-origin: center;
}
.select >>> .el-input__inner {
  background: #010d27;
  border: 1px solid #010d27;
  color: #fff;
}
.select >>> .el-select .el-input.is-focus .el-input__inner {
  border-color: #010d27;
}
.select >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
  content: '';
  position: absolute;
  display: block;
  background-color: #ffbc01;
  height: 4px;
  transform: scale(0.5);
  left: 0;
  right: 0;
  top: 9px;
}
.warn >>> .el-button--warning {
  color: #011c56;
  background-color: #011c56;
  border-color: #011c56;
}
.el-button--warning:focus,
.el-button--warning:hover {
  background: #011c56;
  border-color: #011c56;
  color: #011c56;
}
.hand {
  cursor: pointer;
}
.hand:hover {
  color: #0085ff;
}
</style>

